import { PageTitle } from "Components/Shared/PageTitles/PageTitle";
import type { BackNavigationConfig } from "Navigation/types";
import styled from "styled-components";

const MobileWrapper = styled.div`
  .chevron-wrapper {
    margin-top: 10px;
    margin-left: 10px;
  }

  h1 {
    font-size: 22px;
  }

  .go-back-url {
    h1 {
      margin-top: 6px;
      margin-left: 0;
    }
  }
`;

type Props = {
  title: string;
  onChevronClick?: () => void;
  backNavigation?: BackNavigationConfig;
};

export const PageTitleMobile = ({
  title,
  onChevronClick,
  backNavigation,
}: Props) => (
  <MobileWrapper>
    <PageTitle
      title={title}
      onChevronClick={onChevronClick}
      backNavigation={backNavigation}
    />
  </MobileWrapper>
);
